const logs = {

    PHASE_UPDATE: 'PHASE_UPDATE',
    PLAYER_PHASE_FINISHED: 'PLAYER_PHASE_FINISHED',
    PLAYER_RETIRED: 'PLAYER_RETIRED',

    // // virtual logs added in front
    // GAME_CREATED: 'GAME_CREATED',
    // SEASON_STARTED: 'SEASON_STARTED',
    // RACE_STARTED: 'RACE_STARTED',

}

export default logs



// WEBPACK FOOTER //
// src/utils/constants/logs.js